import React, { useState } from "react";
import AdminEditStoreModal from "./AdminEditStoreModal";
import ActiveFormModal from "../ActiveFormModal";
// import cover from "../../assets/img/user6.png";
import { Link } from "react-router-dom";
import defaultimg from "../../assets/img/user6.png";
import { getAllStores, updateStore } from "../../actions/storeActions";
import { useDispatch } from "react-redux";

const AdminStoreListRow = ({ current, i }) => {
  const [showEditModal, setshowEditModal] = useState(false);
  const openEditModal = () => {
    setshowEditModal((showEditModal) => !showEditModal);
  };
  const [showActiveModal, setshowActiveModal] = useState(false);
  const openActiveModal = () => {
    setshowActiveModal((showActiveModal) => !showActiveModal);
  };
  console.log(current);
  const dispatch = useDispatch();
  // const [values, setValues] = useState({
  //   _id: "",
  //   status: "",
  // });
  const handleSubmit = async (event) => {
    console.log("handleSubmit modal k bhr");

    event.preventDefault();
    const updatedStatus = !current.status; // Toggle the boolean value
    const statusData = {
      _id: current.id,
      status: updatedStatus, // Assign the toggled value
    };
    dispatch(updateStore(statusData));

    setTimeout(() => {
      dispatch(getAllStores());
    }, 1000);
    setshowActiveModal(false);
  };
  const groupAvailabilityByTime = (availability) => {
    const grouped = [];
    let tempGroup = [];

    for (let i = 0; i < availability.length; i++) {
      const current = availability[i];
      const prev = availability[i - 1];

      const isSameAsPrev =
        prev &&
        prev.openTime === current.openTime &&
        prev.closeTime === current.closeTime;

      if (i === 0 || isSameAsPrev) {
        tempGroup.push(current);
      } else {
        grouped.push(tempGroup);
        tempGroup = [current];
      }
    }

    if (tempGroup.length) grouped.push(tempGroup);

    return grouped;
  };

  const availability = current?.availabilityTime || [];

  const groupedAvailability = groupAvailabilityByTime(availability);

  return (
    <>
      <tr key={i}>
        <td>S#0{(i === 1, i + 1)}</td>
        <td>
          <h2>
            <img
              src={
                current?.profilePic?.fileUrl
                  ? current?.profilePic?.fileUrl
                  : defaultimg
              }
              className="default-pic-height rounded border"
              alt=""
              width="50"
              height="50"
            />{" "}
            {current?.name}
          </h2>
        </td>
        <td>{current?.city ? current.city : "New York"}</td>
        <td>{current?.firstName + " " + current?.lastName}</td>
        <td>{current?.storeCommission}%</td>
        {/* <td> 06:30 AM - 10:00 PM </td> */}
        <td>
          {" "}
          {groupedAvailability.map((group, index) => {
            const dayNames = group.map((d) => d.dayName);
            const openTime = group[0].openTime;
            const closeTime = group[0].closeTime;

            const isClosed = !openTime && !closeTime;

            const dayRange =
              dayNames.length > 1
                ? `${dayNames[0]} - ${dayNames[dayNames.length - 1]}`
                : dayNames[0];

            return (
              <div key={index}>
                <strong>{dayRange}</strong>:{" "}
                {isClosed ? "Closed" : `${openTime} - ${closeTime}`}
              </div>
            );
          })}
        </td>
        <td> 4.79 / (57) </td>
        <td>
          {current?.status === true ? (
            <a
              href="#"
              className="btn btn-sm btn-success"
              onClick={openActiveModal}
            >
              Active
            </a>
          ) : (
            <a
              href="#"
              className="btn btn-sm btn-dark"
              onClick={openActiveModal}
            >
              Deactivated
            </a>
          )}
          <a
            href="#"
            className="btn btn-sm btn-primary mx-1"
            onClick={openEditModal}
          >
            Edit
          </a>
          <Link
            to={`/store-details/${current?.id}`}
            className="btn btn-sm btn-warning mx-1"
          >
            View
          </Link>
          <a href="#" className="btn btn-sm btn-danger">
            Delete
          </a>
        </td>
      </tr>
      <ActiveFormModal
        openActiveModal={openActiveModal}
        showActiveModal={showActiveModal}
        current={current}
        handleSubmit={handleSubmit}
      />
      <AdminEditStoreModal
        openEditModal={openEditModal}
        showEditModal={showEditModal}
        current={current}
      />
    </>
  );
};
export default AdminStoreListRow;
